import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Message, Segment, Table } from 'semantic-ui-react';

import InfluencerRow from './influencer-row';
import SkeletonRow from './skeleton-row';
import Pager from './pager';

const hcStyle = { textTransform: 'uppercase', letterSpacing: '0.04em' };

const InfluencersTab = ({
  discussions, page, pageSize, total, isLoading, hasFailed, onPageChange, sort, onSortChange,
}) => {
  if (hasFailed) return <Message error content="Could not load influencers. Please try again." />;
  if (!isLoading && !discussions.length) return <Message info content="No influencers on this campaign yet." />;

  const scannedSorted = sort === '-lastScannedDate' ? 'descending' : 'ascending';

  // No total-count meta from the client, so a short page means we are at the end.
  const isLastPage = discussions.length < pageSize;

  const start = page * pageSize + 1;
  const end = total != null ? Math.min((page + 1) * pageSize, total) : page * pageSize + discussions.length;

  return (
    <Segment.Group>
      <Segment secondary style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#9090a0' }}>
          Showing {start}–{end}{total != null ? ` of ${total}` : ''} influencers
        </span>
        <Pager page={page} isLastPage={isLastPage} disabled={isLoading} onChange={onPageChange} />
      </Segment>
      <Segment>
        <Table sortable basic="very" selectable unstackable style={{ tableLayout: 'fixed' }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell style={{ ...hcStyle, width: '45%' }}>Influencer</Table.HeaderCell>
              <Table.HeaderCell style={{ ...hcStyle, width: 200 }}>Platforms</Table.HeaderCell>
              <Table.HeaderCell textAlign="center" style={{ ...hcStyle, width: 80 }}>Stories</Table.HeaderCell>
              <Table.HeaderCell
                sorted={scannedSorted}
                onClick={onSortChange}
                style={{ ...hcStyle, width: 150 }}
              >
                Last Scanned
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {isLoading
              ? _.times(pageSize, i => <SkeletonRow key={i} />)
              : discussions.map(discussion => (
                <InfluencerRow key={discussion.id} discussion={discussion} />
              ))}
          </Table.Body>
        </Table>
      </Segment>
      <Segment secondary textAlign="center">
        <Pager page={page} isLastPage={isLastPage} disabled={isLoading} onChange={onPageChange} />
      </Segment>
    </Segment.Group>
  );
};

InfluencersTab.propTypes = {
  discussions: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  total: PropTypes.number,
  isLoading: PropTypes.bool.isRequired,
  hasFailed: PropTypes.bool.isRequired,
  onPageChange: PropTypes.func.isRequired,
  sort: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
};

InfluencersTab.defaultProps = {
  total: null,
};

export default InfluencersTab;



/** WEBPACK FOOTER **
 ** ./src/containers/large-campaign/influencers-tab.js
 **/